import React from "react";
import SearchResultPage from "../../templates/search-results-template";
// import {
//     parseSearchUrl,
//     savedSearchParams,
//     propertyH1
// } from "../../../Components/common/site/utils";

const SearchResultSales = (props) => {

    const fullpath = props.location.pathname
    const location = props.location
    const fullpathone = props.location
    // const searchParams = parseSearchUrl("sales", fullpath);

    return (
        <React.Fragment>
            <SearchResultPage 
                locationname="/new-homes-for-sale/" 
                pcategorytype="new_developments" 
                ptype="sales" 
                ptypetag="for-sale" 
                //pstatustype="For Sale" 
                pstatustype= {['For Sale','Exchanged','Under Offer']}
                status = "For Sale"
                fullpathone={fullpathone} 
                fullpathname={fullpath}
                {...props}
                location={location}
            />
        </React.Fragment>
    );
};

export default SearchResultSales;
